/** What the officer says at a checkpoint when he wants a dash. Mainly Twi. Native speakers: edit freely. */
export const POLICE_LINES = {
  ask: ['Aban, ɛte sɛn? Ma me biribi kakra na yɛnkɔ.', 'Driver, ɛte sɛn? Fa biribi kakra ma Aban.', 'Aban ɛti sɛn? Yɛn nso yɛyɛ adwuma... biribi kakra?'],
  paid: ['Ɛyɛ! Everything is good. Kɔ yie!', 'Ayekoo, driver! All good. Kɔ!'],
  refused: ['Ɛyɛ... mebɛhwɛ wo nkrataa no yie.', 'Daabi? Ɛnoɔ me hwɛ w\'nkrataa no.'],
} as const;

export const DASH_BUTTONS = { ten: 'Ma no GH₵10', twenty: 'Ma no GH₵20', refuse: 'Daabi' } as const;
